import {HERO_IMAGE, HERO_OVERLAY_IMAGE, IMAGE, SEPARATOR, STORE_PRODUCT_ONE, STORE_PRODUCT_TWO, BOOKING_ANSWERS} from "./const";
import {External} from "../external";

/**
 * Overrides the fullscreen global toolbox hide
 * @returns
 */
export function toolboxEnableGlobalControl(key) {
  return [
    IMAGE,
    STORE_PRODUCT_ONE,
    STORE_PRODUCT_TWO,
    HERO_OVERLAY_IMAGE,
    HERO_IMAGE,
    SEPARATOR,
    BOOKING_ANSWERS].indexOf(key) !== -1;
}

const setHandle = function (event) {
  const target = External.$(event.target);
  const handle = target.find('.ui-resizable-handle');

  if (target.height() === 0) {
    target.css('height', '2px');
  }

  handle.css('bottom', 0);
  handle.css('top', 0);
  handle.css('height', 'unset');
  handle.css('position', 'absolute');
};

let checkHeight = function (ui) {
  if (ui.size.height < 2) {
    ui.element.css('height', '2px');
  }
};

export function initResizable(topElement, onResizeTop, bottomElement, onResizeBottom, onResizeStop, onResizeStart) {
  topElement.resizable({
    handles: "s",
    minHeight: 0,
    start: onResizeStart,
    stop: function (event, ui) {
      ui.element.css('top', 0);
      checkHeight(ui);
      setHandle(event);
      onResizeStop();
    },
    resize: onResizeTop,
    create: setHandle
  });

  if (bottomElement == null || onResizeBottom == null) {
    return;
  }

  bottomElement.resizable({
    handles: "s",
    minHeight: 0,
    start: onResizeStart,
    stop: function (event, ui) {
      ui.element.css('bottom', 0);
      checkHeight(ui);
      setHandle(event);
      onResizeStop();
    },
    resize: onResizeBottom,
    create: setHandle
  });
}